<dx-toolbar [items]="toolbar"></dx-toolbar>
<div [ngClass]="gridClass">
  <ng-content select="app-dashboard-widget"></ng-content>
</div>
